import { ResponseType } from 'axios';
import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { ChangeRequestTypeEnum } from 'src/constants/change-request';
import { IChangeRequestBody } from 'src/interfaces/change-request';
import { DTO } from './base.dto';

export class GetChangeChangeRequestDto extends DTO {
	public param: undefined;
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CHANGE_REQUEST;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor() {
		super();
	}
}

export class CreateOrUpdateChangeChangeRequestDto extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IChangeRequestBody;
	public url: string = ENDPOINT.CHANGE_REQUEST;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IChangeRequestBody) {
		super();
		this.body = body;
	}
}

export class GetExistingDto extends DTO {
	public param: { accountId: string; type: ChangeRequestTypeEnum };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CHANGE_REQUEST_EXISTING;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { accountId: string; type: ChangeRequestTypeEnum }) {
		super();
		this.param = param;
	}
}

export class DeleteChangeRequestDto extends DTO {
	public param: { crId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CHANGE_REQUEST_DELETE_CHANGE_REQUEST;
	public method: HTTP_METHOD = HTTP_METHOD.DELETE;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { crId: string }) {
		super();
		this.param = param;
	}
}

export class FileDeleteFileDTO extends DTO {
	public param: { documentId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.CHANGE_REQUEST_FILE_DELETE;
	public method: HTTP_METHOD = HTTP_METHOD.DELETE;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { documentId: string }) {
		super();
		this.param = param;
	}
}

export class GetListChangeChangeRequestDto extends DTO {
	public param: undefined;
	public query: { pageNumber: number, pageSize: number };
	public body: undefined;
	public url: string = ENDPOINT.LIST_CHANGE_REQUEST;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(query: { pageNumber: number, pageSize: number }) {
		super();
		this.query = query;
	}
}
